import React from 'react';
import cn from 'classnames';
import LocalisedPhone from 'components/LocalisedPhone';
import Icon from 'components/UI/Icon';
import { useIsRegion, useLang, useLocalisedEmail } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';
import { arabicRegion } from 'define/locale';
import { WHATSAPP_LINK } from 'define';
import * as styles from './Contacts.module.scss';

function Contacts({ className, theme, blockLocation }) {
  const lang = useLang();
  const localisedEmail = useLocalisedEmail();
  const isMena = useIsRegion(arabicRegion);
  const showMenaContent = lang === 'ae' || (lang === 'en' && isMena);

  const handlePushEvent = eventName => {
    pushCustomEvent(eventName, {
      action: 'click_on_link',
      label: blockLocation,
      pageUrl: window.location.href,
    });
  };

  return (
    <div className={cn(className, styles.wrapper, theme && styles[theme])}>
      <LocalisedPhone defaultLocale={lang}>
        {phone => (
          <a href={`tel:${phone}`} className={styles.link}>
            <Icon name="phone-filled" className={cn(styles.icon, styles.iconPhone)} />
            {phone}
          </a>
        )}
      </LocalisedPhone>
      <a
        href={`mailto:${localisedEmail}`}
        className={styles.link}
        onClick={() => handlePushEvent('ndrsn_email')}
      >
        <Icon name="mail" className={cn(styles.icon, styles.iconMail)} />
        {localisedEmail}
      </a>
      {showMenaContent && (
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          className={styles.link}
          rel="noreferrer noopener nofollow"
          onClick={() => handlePushEvent('ndrsn_whatsapp')}
        >
          <Icon name="whatsapp" className={cn(styles.icon, styles.iconWhatsApp)} />
          WhatsApp
        </a>
      )}
    </div>
  );
}

export default Contacts;
